var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReviewIcon = function SvgReviewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    x: 1.5,
    y: 1.5,
    stroke: "currentColor",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M7.573 5.201a.5.5 0 0 1 .854 0l.722 1.186a.5.5 0 0 0 .295.223l1.333.365a.5.5 0 0 1 .262.79l-.897 1.149a.5.5 0 0 0-.105.335l.082 1.459a.5.5 0 0 1-.69.49l-1.239-.51a.5.5 0 0 0-.38 0l-1.24.51a.5.5 0 0 1-.689-.49l.082-1.459a.5.5 0 0 0-.105-.335L4.96 7.765a.5.5 0 0 1 .262-.79l1.333-.365a.5.5 0 0 0 .295-.223z"
  })));
};
export default SvgReviewIcon;